import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "./lib/auth";
import Landing from "./pages/Landing";
import Auth from "./pages/Auth";
import AuthCallback from "./pages/AuthCallback";
import DashboardLayout from "./pages/DashboardLayout";
import DashboardHome from "./pages/DashboardHome";
import VideoWizard from "./pages/VideoWizard";
import VideoGallery from "./pages/VideoGallery";
import Packages from "./pages/Packages";
import SharedVideo from "./pages/SharedVideo";
import { IadeSartlariPage, TeslimatPage, KvkkPage, CerezPolitikasiPage } from "./pages/LegalPage";
import CookieBanner from "./components/CookieBanner";

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) {
    return (
      <div className="min-h-screen bg-[#020617] flex items-center justify-center">
        <div className="text-slate-400 text-sm tracking-[0.3em] uppercase">Yükleniyor…</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace state={{ from: location }} />;
  return children;
}

function AppRouter() {
  const location = useLocation();
  // CRITICAL: detect session_id during render (not in useEffect) to avoid race conditions
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/v/:slug" element={<SharedVideo />} />
      <Route path="/iptal-iade" element={<IadeSartlariPage />} />
      <Route path="/teslimat" element={<TeslimatPage />} />
      <Route path="/kvkk" element={<KvkkPage />} />
      <Route path="/cerez-politikasi" element={<CerezPolitikasiPage />} />
      <Route path="/login" element={<Auth mode="login" />} />
      <Route path="/register" element={<Auth mode="register" />} />
      <Route path="/dashboard" element={<ProtectedRoute><DashboardLayout /></ProtectedRoute>}>
        <Route index element={<DashboardHome />} />
        <Route path="create" element={<VideoWizard />} />
        <Route path="videos" element={<VideoGallery />} />
        <Route path="packages" element={<Packages />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppRouter />
        <CookieBanner />
        <Toaster theme="dark" position="top-right" richColors closeButton />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
